export default "__VITE_PUBLIC_ASSET__124437c8__"